module.exports = __webpack_public_path__ + "img/selected0-min.1a44c2ac.png";